import { render } from "./ContrattiVenditaDetail.vue?vue&type=template&id=00e9483d&scoped=true"
import script from "./ContrattiVenditaDetail.vue?vue&type=script&lang=js"
export * from "./ContrattiVenditaDetail.vue?vue&type=script&lang=js"

import "./ContrattiVenditaDetail.vue?vue&type=style&index=0&id=00e9483d&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e9483d"]])

export default __exports__